import styled from 'styled-components';

export type BadgeSize = 'small' | 'medium';

export const BadgeContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['withborder', 'size'].includes(prop),
})<{
  withborder: boolean;
  size: BadgeSize;
}>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: ${({ size }) => (size === 'small' ? '0.75rem' : '0.875rem')};
  font-weight: 500;
  line-height: 1rem;
  color: rgba(38, 38, 38, 1);
  cursor: pointer;
  user-select: none;

  ${({ withborder }) => {
    if (!withborder) {
      return '';
    }

    return `
      padding: 0.25rem 0.5rem;
      border: 1px solid #D9D9D9;
      border-radius: 9999px;
      background: white;
    `;
  }}

  &:hover {
    opacity: 0.8;
  }

  transition: opacity 0.2s ease;
`;

export const BadgeIcon = styled.span.withConfig({
  shouldForwardProp: (prop) => !['size'].includes(prop),
})<{
  size: BadgeSize;
}>`
  display: inline-flex;
  align-items: center;

  svg {
    width: ${({ size }) => (size === 'small' ? '12px' : '14px')};
    height: ${({ size }) => (size === 'small' ? '12px' : '14px')};
  }
`;

export const BadgeText = styled.span`
  white-space: nowrap;
`;

export const MenuItem = styled.div`
  padding: 8px 0;

  .menu-item-label {
    font-weight: 500;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.85);
  }

  .menu-item-description {
    font-size: 11px;
    color: rgba(0, 0, 0, 0.65);
    margin-top: 2px;
  }
`;
